import toast from './toast'
import borrowerTaskGroup from './borrowerTaskGroup'
import verificationsIframe from './verificationsIframe'
import ChatStore from '~/components/chat/v2/store'
import * as settingsDialogStore from './settingsDialogStore'
import * as privacyPolicyStore from './privacyPolicyStore'
import leadGenStore from '../../LeadGen/store/leadGenStore.js'
import loanAppGuide from './loanAppGuide'
import mortgageAdvisor from './mortgageAdvisor'

export default {
  toast,
  borrowerTaskGroup,
  verificationsIframe,
  settingsDialogStore,
  privacyPolicyStore,
  Chat: ChatStore,
  leadGenStore,
  loanAppGuide,
  mortgageAdvisor
}
